export default __webpack_public_path__ + "static/media/archive.bc080182.jpg";